import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { history, Link } from '@umijs/max';

const loginPath = '/login';

// 错误处理方案： 错误类型
enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}
// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  errorCode?: number;
  errorMessage?: string;
  showType?: ErrorShowType;
}

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  timeout: 10000,
  // 错误处理： umi@3 的错误处理方案。
  errorConfig: {
    // 错误接收及处理
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;

      // 1. 构造错误对象
      const customError = {
        success: false,
        errorCode: error.response?.status || 500,
        errorMessage: error.response?.data?.error || error.message,
        showType: error.showType || 2, // 0静默 1警告 2错误提示
      };

      // 2. 按需抛出
      if (error.response?.status === 401) {
        history.push(loginPath);
      }

      throw customError; // 继续向上抛出
    },
  },
};
